import { Injectable, Injector } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import {ApiAuthService} from "../services/apiauth.service";
import {NdmsAuthService} from "../../../../ndms/app/shared/core-ndms/services/ndms-auth.service";

@Injectable()
export class NdmsAuthenticationGuard implements Resolve<any> {

  constructor(private injector: Injector) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    const authApiService: NdmsAuthService = this.injector.get(NdmsAuthService);

    return true;
  }

}
